import { Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';

import { isWebView } from 'shared/constants/AppTypeConstants';
import { formatPlural } from 'shared/helpers/IntlHelpers';
import { PermissionIcon } from 'shared/icons/PermissionIcon';
import { WebviewLayout } from 'shared/layout/WebviewLayout';

interface ACHNoAccessViewProps {
  hoursUntilUpdateAllowed: number;
}

function ACHNoAccessViewContent({
  hoursUntilUpdateAllowed,
}: ACHNoAccessViewProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
    >
      <Box width="440px">
        <Stack align="center" space="medium">
          <PermissionIcon />

          <Stack align="center" space="xsmall">
            <Typography variant="h3">No Access</Typography>

            <Typography align="center" color="textSecondary">
              You have changed your email/phone in the last 24 hours. You
              can&apos;t change ACH bank details for {hoursUntilUpdateAllowed}{' '}
              {formatPlural(hoursUntilUpdateAllowed, 'hour', 'hours')}.
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}

export function ACHNoAccessView({
  hoursUntilUpdateAllowed,
}: ACHNoAccessViewProps) {
  if (isWebView) {
    return (
      <WebviewLayout scrollable={false}>
        <ACHNoAccessViewContent
          hoursUntilUpdateAllowed={hoursUntilUpdateAllowed}
        />
      </WebviewLayout>
    );
  }

  return (
    <ACHNoAccessViewContent hoursUntilUpdateAllowed={hoursUntilUpdateAllowed} />
  );
}
